const availableFeatureFlags = ["protectReviews"] as const;

type K = typeof availableFeatureFlags[number];

export const getFeatureFlag = (featureFlags: Record<K, unknown>) =>
  <T>(key: K, defaultValue?: T): T | undefined => {
  const value = featureFlags[key];
  return value as T ?? defaultValue;
};
